import { Col, Container, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch} from "react-redux";
import { getPageConfig, toggleDefaultIntegration, toggleHighlight, toggleShouldMountIntegrationByDefault, setSessionApiHost } from "./PageConfigSlice";

function PageConfig() {
  const pageConfig = useSelector(getPageConfig);
  const dispatch = useDispatch();
  return (
    <>
      <Container>
        <Row>
          <Col>
            <Form>
              <Form.Check
                type="switch"
                id="defaultIntegration"
                label="Use default Integration"
                checked={pageConfig.isDefaultIntegration}
                onChange={()=>dispatch(toggleDefaultIntegration())}/>
              <Form.Check
                type="switch"
                id="integrationHighlight"
                label="Use integration highlight"
                checked={pageConfig.isHighlightActive}
                onChange={()=>dispatch(toggleHighlight())}/>
              <Form.Check
                type="switch"
                id="shouldMountIntegrationByDefault"
                label="Use integration.start() by default"
                checked={pageConfig.shouldMountIntegrationByDefault}
                onChange={()=>dispatch(toggleShouldMountIntegrationByDefault())} />
              <Form.Group className="mt-3">
                <Form.Label>Session API Host</Form.Label>
                <Form.Select
                  value={pageConfig.sessionApiHost}
                  onChange={(e)=>dispatch(setSessionApiHost(e.target.value))}>
                  <option value="">Select or enter custom...</option>
                  <option value="https://sessions.fitanalytics.com">https://sessions.fitanalytics.com</option>
                  <option value="https://sessions-staging1.fitanalytics.com">https://sessions-staging1.fitanalytics.com</option>
                  <option value="https://sessions-staging2.fitanalytics.com">https://sessions-staging2.fitanalytics.com</option>
                  <option value="http://localhost:3003">http://localhost:3003</option>
                  <option value="custom">Custom</option>
                </Form.Select>
                {pageConfig.sessionApiHost === 'custom' && (
                  <Form.Control
                    type="text"
                    className="mt-2"
                    placeholder="Enter custom session-api host URL"
                    onChange={(e)=>dispatch(setSessionApiHost(e.target.value))} />
                )}
              </Form.Group>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PageConfig;
